<template>
  <div v-if="widget" class="widget-form-container">
    <div class="section-container">
      <substrate-mount>
        <div class="input-container">
          <input-price
            v-model.lazy="widget.minDisplayAmount"
            input-id="widget.minDisplayAmount"
            :input-name="`${$t('showing.minimum.cost')}, ${currency.sign}`"
            :min-value="0"
            :currency="currency"
            @change="widget.minDisplayAmount = $event"
          />
        </div>
        <div class="input-container">
          <input-price
            v-model.lazy="widget.premiumDisplayAmount"
            input-id="widget.premiumDisplayAmount"
            :input-name="`${$t('premium.messages')}, ${currency.sign}`"
            :min-value="0"
            :error="!isValid"
            :currency="currency"
            @change="widget.premiumDisplayAmount = $event"
          />
        </div>
      </substrate-mount>
    </div>

    <div class="button-primary-container">
      <cs-button :width="buttonWidth" :disabled="!isValid" @click="onSubmit">
        {{ $t('common.proceed') }}
      </cs-button>
    </div>
  </div>
</template>

<script>
import { mapState, mapGetters } from 'vuex';

import MessageWidget from 'services/widget/MessageWidget';

import InputPrice from '@/components/inputElements/InputPrice';
import SubstrateMount from '@/components/capusta/SubstrateMount';

export default {
  name: 'MessageWidget',
  components: {
    InputPrice,
    SubstrateMount,
  },
  props: {
    widgets: {
      type: Array,
      default: () => [],
    },
  },
  created() {
    this.initialize();
  },
  data() {
    return {
      widget: null,
    };
  },
  computed: {
    currency() {
      return this.PROJECT_INFO.currency;
    },
    isValid() {
      const { premiumDisplayAmount } = this.widget;

      if (this.$validate.isEmptyString(premiumDisplayAmount)) {
        return true;
      }

      return this.widget.isValidPremiumAmount();
    },
    buttonWidth() {
      return this.isDesktop ? 223 : '100%';
    },
    ...mapState(['PROJECT_INFO']),
    ...mapGetters(['isDesktop']),
  },
  methods: {
    onSubmit() {
      this.$emit('submit', this.widget.getData());
    },
    initialize() {
      this.widget = new MessageWidget({
        currency: this.currency,
      });

      const data = this.widgets
        .find(widget => widget.type === this.widget.type);

      if (this.$validate.isUndefined(data)) {
        return;
      }

      this.widget.setData({
        ...data,
        currency: this.currency,
      });
    },
  },
};
</script>

<style lang="sass" scoped>
  @import '~styles/components/widgets/widget-form'
</style>
